var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// D:/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/node_modules/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = polyfills